<template>
  <div class="app-container">
    <!-- <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
      label-width="68px"
    >
      <el-form-item label="字典名称" prop="dictName">
        <el-input
          v-model="queryParams.dictName"
          placeholder="请输入字典名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form> -->

    <el-table :data="applicationAgentlist" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="序号" align="center" prop="company_id" />
      <el-table-column label="机构名称" align="center" prop="company_name" />
      <el-table-column label="机构地址" align="center" prop="contact_address" />
      <el-table-column label="联系人" align="center" prop="corporate_information" />
      <el-table-column label="联系电话" align="center" prop="corporate_phone" />
      <el-table-column label="机构类型" align="center" prop="enterprise_nature" />
      <el-table-column label="法人姓名" align="center" prop="corporate_information" />
      <el-table-column label="法人身份证号" align="center" prop="corporate_id_number" />
      <el-table-column label="法人电话" align="center" prop="corporate_phone" />
      <el-table-column label="统一社会信用代码" align="center" prop="unify_social_credit_code" />
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="mini" type="text" icon="el-icon-edit" @click="handleAdd(scope.row)">申请代理</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />-->

    <!-- 添加或修改字典类型对话框 -->
    <el-dialog title="详情" :visible.sync="open" width="70%">
      <el-form ref="elForm" :model="formData" :rules="rules" size="medium" label-width="100px">
        <el-form-item label="姓名" prop="field101">
          <el-input
            v-model="formData.field101"
            placeholder="请输入姓名"
            clearable
            :style="{width: '100%'}"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="mobile">
          <el-input
            v-model="formData.mobile"
            placeholder="请输入联系方式"
            :maxlength="11"
            show-word-limit
            clearable
            prefix-icon="el-icon-mobile"
            :style="{width: '100%'}"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="field102">
          <el-input
            v-model="formData.field102"
            placeholder="请输入身份证号"
            clearable
            :style="{width: '100%'}"
          ></el-input>
        </el-form-item>
        <el-form-item label="证件有效期" prop="field103">
          <el-date-picker
            v-model="formData.field103"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :style="{width: '100%'}"
            placeholder="请选择证件有效期"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="身份证照片" prop="field104" required>
          <div style="display: flex;">
            <el-upload
              ref="field104"
              :file-list="field104fileList"
              :action="field104Action"
              :before-upload="field104BeforeUpload"
              list-type="picture-card"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-upload
              ref="field104"
              :file-list="field104fileList"
              :action="field104Action"
              :before-upload="field104BeforeUpload"
              list-type="picture-card"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item size="large">
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import { listType, getType, delType, addType, updateType } from "../../api/system/type";
import { applicationAgent, shenqing } from "../../api/system/applicationAgent";

export default {
  name: "Type",
  data() {
    return {
      applicationAgentlist: [],
      // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      formData: {
        field101: undefined,
        mobile: "",
        field102: undefined,
        field103: null,
        field104: null
      },
      rules: {
        field101: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }
        ],
        mobile: [
          {
            required: true,
            message: "请输入联系方式",
            trigger: "blur"
          },
          {
            pattern: /^1(3|4|5|7|8|9)\d{9}$/,
            message: "手机号格式错误",
            trigger: "blur"
          }
        ],
        field102: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: "blur"
          }
        ],
        field103: [
          {
            required: true,
            message: "请选择证件有效期",
            trigger: "change"
          }
        ]
      },
      field104Action: "https://jsonplaceholder.typicode.com/posts/",
      field104fileList: [],
      tableData: [],
      // 字典类型表格数据
      typeList: [
        {
          createBy: "admin",
          createTime: "2022-08-01 12:01:35",
          dictId: 1,
          dictName: "用户性别",
          dictType: "sys_user_sex",
          params: {},
          remark: "用户性别列表",
          searchValue: null,
          status: "0",
          updateBy: null,
          updateTime: null
        }
      ],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        dictName: null,
        dictType: null,
        status: null
      },
      // 表单参数
      form: {},
      formLabelAlign: {
        name: "namne",
        legal_person: "legal_person",
        legal_person_telphone: "legal_person_telphone",
        type: "type",
        legal_person_idcard: "legal_person_idcard",
        credit_code: "credit_code"
      },
      // 申请代理参数
      daili_params:{},

    };
  },
  created() {
    this.getList();
    this.applicationAgents();
  },
  methods: {
    applicationAgents() {
      this.user_id = sessionStorage.getItem("user_id");
      console.log(this.user_id);
      applicationAgent(this.user_id).then(response => {
        console.log(response);
        this.applicationAgentlist = response.data.data.rows;
      });
    },
    submitForm() {
      //   this.$refs['elForm'].validate(valid => {
      //     if (!valid) return
      //     // TODO 提交表单
      //   })
    },
    resetForm() {
      //   this.$refs['elForm'].resetFields()
    },
    field104BeforeUpload(file) {
      //   let isRightSize = file.size / 1024 / 1024 < 2
      //   if (!isRightSize) {
      //     this.$message.error('文件大小超过 2MB')
      //   }
      //   return isRightSize
    },
    handleClick(row) {
      console.log(row);
    },
    /** 查询字典类型列表 */
    getList() {
      this.loading = true;
      // listType(this.queryParams).then((response) => {
      //   this.typeList = response.rows;
      //   this.total = response.total;
      //   this.loading = false;
      // });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        dictId: null,
        dictName: null,
        dictType: null,
        status: "0",
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        remark: null
      };
      // this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      // this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.dictId);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    /** 申请代理按钮 */
    handleAdd: async function( row ) {
      console.log(row);
      this.daili_params.company_id = row.company_id;
      this.daili_params.user_id = sessionStorage.getItem('user_id')
      await shenqing(this.daili_params).then(res => {
        if (res.data.code == 1) {
          this.$message.success("申请成功");
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.dictId != null) {
            updateType(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addType(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const dictIds = row.dictId || this.ids;
      this.$modal
        .confirm('是否确认删除字典类型编号为"' + dictIds + '"的数据项？')
        .then(function() {
          return;
          delType(dictIds);
        })
        .then(() => {
          this.getList();
          this.$modal.msgSuccess("删除成功");
        })
        .catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download(
        "system/type/export",
        {
          ...this.queryParams
        },
        `type_${new Date().getTime()}.xlsx`
      );
    }
  }
};
</script>
<style scoped>
.showphoto {
  height: 553px;
  background: #f5f6fa;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.showphoto1 {
  height: 553px;
  background: #f5f6fa;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-tabs__nav .el-tabs__item.is-active{
  background: #409EFF;
}

</style>



// WEBPACK FOOTER //
// src/view/agencies/applicationAgent.vue